import type { DiffTaxonomyImportRequest } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { getApiError } from '@/types/apiError';
import { useMutation } from '@tanstack/react-query';

export const useDiffTaxonomyImport = (taxonomyId: string) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  const { mutateAsync, isPending, error } = useMutation({
    mutationFn: (data: DiffTaxonomyImportRequest) => api.taxonomy.diffTaxonomyImport(tenantId, taxonomyId, data),
  });

  return {
    diffImport: mutateAsync,
    isDiffing: isPending,
    diffError: getApiError(error),
  };
};
